module.exports = __webpack_public_path__ + "static/media/shaws.c96bc261.svg";